import { Box, Button } from "@carrotfertility/carotene-core"
import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import {
  DialogTimeTapScheduler,
  useReportToHeapTimeTapChatScheduled,
  TimeTapEnvironment,
  TimeTapConfirmationDialog
} from "#/components/time-tap/TimeTapScheduler"

export const FindASessionButton = ({
  groupSlugId,
  reasonId,
  locationId,
  timeTapEnvironment
}: {
  groupSlugId: string
  reasonId: number
  locationId?: number
  timeTapEnvironment?: TimeTapEnvironment
}): JSX.Element => {
  const [showChatConfirmation, setShowChatConfirmation] = useState(false)
  const [open, setOpen] = useState(false)

  useReportToHeapTimeTapChatScheduled(
    setShowChatConfirmation,
    {
      eventName: "Group chat scheduled",
      properties: {
        "Group Slug ID": groupSlugId
      }
    },
    Boolean(groupSlugId)
  )

  return (
    <>
      <Button id="find-group-session-button" onClick={() => setOpen(true)}>
        <FormattedMessage defaultMessage="Find a session" />
      </Button>
      <Box>
        <DialogTimeTapScheduler
          reasonId={reasonId}
          locationId={locationId}
          open={open && !showChatConfirmation}
          setOpen={setOpen}
          timeTapEnvironment={timeTapEnvironment}
        />
        <TimeTapConfirmationDialog
          open={showChatConfirmation}
          onClose={() => {
            setOpen(false)
            setShowChatConfirmation(false)
          }}
          chatType="GROUPS"
        />
      </Box>
    </>
  )
}
